import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '@frontend/util-client-auth';
import { LangRouterService } from '@frontend/util-router-history';

export const authGuard: CanActivateFn = async () => {
  const loginService = inject(LoginService);
  const router = inject(Router);
  const localizeService = inject(LangRouterService);

  const isLoggedIn = await loginService.isLoggedIn();

  if (!isLoggedIn) {
    router.navigate([localizeService.translateRoute('/categories') as string]);
    return false;
  }

  return true;
};
